<template>
    <div>
        <div class="game-comp">
            <div class="lint">
                <span class="time"><img src="/static/img/game/time-icon.png" />{{ timeLeft }}</span>
                <span class="prizes" v-if="isVersion2" >{{ packagesFound }}&nbsp;{{ packagesFound === 1 ? 'Prijs' : 'Prijzen' }}</span>
                <span class="score" v-else ><img src="/static/img/game/score-icon.png" />{{ scoreButReallyDottified }}</span>
            </div>
            <div class="canvas-wrapper">
                <canvas ref="gamecanvas" width="500" height="500"></canvas>
            </div>
            <div class="specials">
                <div class="elem-wrapper" v-for="n in 5">
                    <img class="elem" :ref="'package' + n" :src="'/static/img/game/elem' + n + '.png'" />
                    <img class="outline" src="/static/img/game/elem-outline.png" />
                    <p v-if="isVersion2">{{ prizeNames[n - 1] }}</p>
                </div>
            </div>
        </div>

        <transition v-on:leave="fadeOutDarken" v-on:enter="fadeInDarken" appear>
            <div v-show="darken" class="darken-layer"></div>
        </transition>

        <v-countdown :trigger="readyForCountdown" :from="3" ref="countdown" @complete="countdownComplete"></v-countdown>

        <div class="final-score-display" v-show="showSnowsplosion">
            <v-snowsplosion ref="splosion" :size="snowWidth * 2" :autoAnimate="false" :autoFadeOut="score > 0" :complexity="browserCheck.isMobile ? 0.1 : 1"></v-snowsplosion>
            <!-- <img class="snowflake" src="/static/img/game/snowflake.png" /> -->
            <span class="final-score" v-if="isVersion2" >{{ packagesFound }}&nbsp;Prijzen</span>
            <span class="final-score" v-else >&euro;{{ dottify( endAnimScore ) }}</span>
            <button class="restart-button" @click="restartGame">Speel snel opnieuw</button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
    import Vue from 'vue';
    import { TweenMax, TimelineMax } from '@/vendor';
    import { dottify, browserCheck } from '@/app/mixins';
    import JingleBalls from '@/app/game/Main';
    import Snowsplosion from '@/app/components/Snowsplosion';
    import Countdown from '@/app/components/Countdown';

    export default {
        components: {
            'v-countdown': Countdown,
            'v-snowsplosion': Snowsplosion
        },

        mixins: [ dottify, browserCheck ],

        data()
        {
            return {
                prizeNames: [ 'Rituals Pakket', 'Sonos Beam', 'Sonos Play 1', 'Apple iPad', 'LG TV' ],
                packagesFound: 0,
                snowWidth: 500,
                darken: true,
                readyForCountdown: false,
                now: Date.now(),
                gameEnd: new Date( Date.now() + 1 * 30000 ),
                timePenalty: 0,
                scoreButReally: 0,
                endAnimScore: 0,
                showSnowsplosion: false
            };
        },

        computed: {
            isVersion2()
            {
                return this.$store.getters.isVersion2;
            },

            minutesLeft()
            {
                let msLeft = this.gameEnd - this.timePenalty - this.now;
                return msLeft / 1000 / 60;
            },

            timeLeft()
            {
                if( this.minutesLeft < 0 )
                {
                    return '00:00';
                }
                return Math.floor( this.minutesLeft ).toString().padStart( 2, '0' ) + ':' + Math.round( ( this.minutesLeft % 1 ) * 60 ).toString().padStart( 2, '0' );
            },

            score()
            {
                return this.$store.getters[ 'game/score' ];
            },

            scoreDisplay()
            {
                return this.score.toString().padStart( 4, '0' );
            },

            scoreButReallyDottified()
            {
                if( this.scoreButReally < 1000 )
                {
                    return this.dottify( this.scoreButReally.toString().padStart( 3, '0' ) );
                }
                return this.dottify( this.scoreButReally.toString() );
            }
        },

        watch: {
            score: function( pVal )
            {
                if( this.scoreTween )
                {
                    this.scoreTween.kill();
                }

                this.scoreTween = TweenMax.to({ foo: this.scoreButReally }, 0.3, {
                    foo: pVal,
                    delay: 1.8,
                    onUpdateParams: [ '{self}', this ],
                    onUpdate: ( tween, pThis ) =>
                    {
                        pThis.scoreButReally = Math.round( tween.target.foo );
                    }
                });
            },

            '$route': function( pVal )
            {
                if( pVal.name === 'Game' )
                {
                    this.readyForCountdown = true;
                }
            }
        },

        mounted()
        {
            this.endWasCalled = false;
            this.packagesFound = 0;

            let shouldLegacy = false;

            if( browserCheck.isIE === true || browserCheck.isEdge === true || browserCheck.isiPad === true || browserCheck.isOldIOS === true )
            {
                shouldLegacy = true;
            }

            this.game = new JingleBalls({ view: this.$refs.gamecanvas, version2: this.isVersion2, legacy: shouldLegacy });
            this.game.eventHub.on( 'foundSpecial', this.addScore );
            this.game.eventHub.on( 'startPresentAnim', this.animPackage );

            TweenMax.set( '.elem-wrapper > .elem', { autoAlpha: 0 });
            TweenMax.set( '.restart-button', { x: '-50%', autoAlpha: 0 });

            if( this.$route.name === 'Game' )
            {
                this.readyForCountdown = true;
            }
        },

        methods: {
            countdownComplete()
            {
                this.darken = false;
                this.gameEnd = new Date( Date.now() + 1 * 30000 );
                this.now = Date.now();
                this.nowInterval = setInterval( () =>
                {
                    if( this.minutesLeft <= 0 )
                    {
                        this.showSnowsplosion = true;
                        Vue.nextTick( this.gameEndCall( 0 ) );
                    }
                    else
                    {
                        this.now = Date.now();
                    }
                }, 1000 );

                this.snowWidth = this.$refs.gamecanvas.getBoundingClientRect().width * 1.3448673587081891580161476355248; // magic num = 1166 / 867 (orig asset ratios)
            },

            addScore( pData )
            {
                if( pData.score )
                {
                    if( pData.id )
                    {
                        this.packagesFound ++;
                        this.$store.dispatch( 'game/foundBonus', { value: pData.id });
                    }

                    this.$store.dispatch( 'game/score', { value: pData.score });
                }

                if( pData.time )
                {
                    this.timePenalty += pData.time * 1000;
                }
            },

            animPackage( pData )
            {
                let canvasPos = this.$refs.gamecanvas.getBoundingClientRect();
                let packagePos = this.$refs[ 'package' + pData.id ][0].getBoundingClientRect();

                let elem = this.$refs[ 'package' + pData.id ][0];

                let tl = new TimelineMax();

                let scalar = canvasPos.width / 500;

                tl.fromTo( elem, 0.3, { autoAlpha: 0 }, { autoAlpha: 1 }, 0 );
                tl.fromTo( elem, 1, {
                    x: canvasPos.left + ( pData.pos.x - pData.width / 2 ) * scalar,
                    y: canvasPos.top + ( pData.pos.y - pData.height / 2 ) * scalar,
                    width: pData.width * scalar,
                    position: 'fixed'
                }, {
                    delay: 1,
                    x: packagePos.left,
                    y: packagePos.top,
                    width: packagePos.width,
                    ease: Expo.easeInOut,
                    onComplete: () =>
                    {
                        TweenMax.set( elem, { x: 0, y: 0, width: '100%', position: 'absolute' });
                    }
                }, 0.2 );

                if( this.packagesFound === 5 && this.minutesLeft > 0 )
                {
                    this.showSnowsplosion = true;
                    this.snowAnim = this.$refs.splosion.getAnimation();
                    Vue.nextTick( this.gameOver( 1 ) );
                }
            },

            gameEndCall( pDelay )
            {
                this.snowAnim = this.$refs.splosion.getAnimation();
                // do ingame anim
                if( this.endWasCalled === true )
                {
                    return;
                }

                TweenMax.set( '.final-score', { x: '-50%', y: '-62%', opacity: 0 });

                this.endWasCalled = true;
                this.game.gameEndAnim( this.gameOver.bind( this, pDelay ) );
            },

            gameOver( pDelay )
            {
                clearInterval( this.nowInterval );
                this.showSnowsplosion = true;

                TweenMax.to( createjs.Sound, 1, {
                    volume: 0.3,
                    onComplete: () =>
                    {
                        createjs.Sound.play( 'bells', { volume: 1 });
                    }
                });

                TweenMax.set( '.final-score', { x: '-50%', y: '-62%', opacity: 0 });

                // createjs.Sound.play( 'bells', { volume: 0.1 });

                this.endGameAnim = new TimelineMax({ delay: pDelay });

                this.endGameAnim.add( () =>
                {
                    this.darken = true;
                }, 0.3 );

                this.endGameAnim.add( () =>
                {
                    this.snowAnim.play();
                }, 0 );
                this.endGameAnim.fromTo( '.final-score', 0.3, { opacity: 0 }, { opacity: 1 }, 1.75 ); // 1.75
                this.endGameAnim.to( this, 2, { roundProps: [ 'endAnimScore' ], endAnimScore: this.score, ease: Circ.easeInOut }, 1 ); // 0.75

                if( this.score === 0 )
                {
                    this.endGameAnim.fromTo( '.restart-button', 0.3, { autoAlpha: 0 }, { autoAlpha: 1 }, 5 );
                }
                else
                {
                    this.endGameAnim.to( '.final-score', 0.75, { scale: 2, autoAlpha: 0, ease: Back.easeIn }, 4.5 );
                    this.endGameAnim.add( this.routeToNaw, 6 );
                }
            },

            destroyGame()
            {
                if( this.endGameAnim )
                {
                    this.endGameAnim.kill();
                }

                this.readyForCountdown = false;
                this.darken = true;
                this.game.destroy();
                clearInterval( this.nowInterval );
            },

            restartGame()
            {
                this.$emit( 'reload' );
                this.$router.push( '/spel/uitleg' );
            },

            routeToNaw()
            {
                this.$router.push( '/gegevens' );
            },

            fadeOutDarken()
            {
                TweenMax.to( '.darken-layer', 0.3, { autoAlpha: 0 });
            },

            fadeInDarken()
            {
                TweenMax.to( '.darken-layer', 0.3, { autoAlpha: 1 });
            }
        },

        beforeDestroy()
        {
            this.destroyGame();
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/Game.vue